// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewItem-Action_cls1__W+nvg","cls2":"PaymentViewItem-Action_cls2__vdjHJ PaymentViewItem-Action_cls1__W+nvg"};